// extracted by mini-css-extract-plugin
module.exports = {"home":"page_home__NrX8Y","tagline":"page_tagline__EZUM_","release":"page_release__WAzjx"};